(function () {
  "use strict";

  function publish(name, detail) {
    var payload = Object.assign({
      path: window.location.pathname,
      brandContext: "rems"
    }, detail || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, rems: payload });
    document.dispatchEvent(new CustomEvent(name, { detail: payload }));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
      try { window.Shopify.analytics.publish(name, payload); } catch (error) { /* Shopify may reject unregistered events. */ }
    }
  }

  document.addEventListener("click", function (event) {
    var link = event.target.closest("[data-rems-track]");
    if (!link) return;
    publish(link.getAttribute("data-rems-track"), {
      label: link.getAttribute("data-rems-label") || link.textContent.trim().replace(/\s+/g, " ").slice(0, 120),
      destination: link.getAttribute("href") || "",
      scope: link.getAttribute("data-rems-scope") || ""
    });
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest(".rems-request__form");
    if (!form) return;
    publish("rems_project_request_submit", {
      category: form.querySelector("[name='contact[Project category]']")?.value || ""
    });
  });

  window.REMSStorefrontAnalytics = { publish: publish };
})();
